import { buildModelManager } from "../builder.js";
const DefaultAnonymizationEventSelection = {
  __typename: true,
  id: true,
  createdAt: true,
  fieldsScrubbed: true,
  modelsTouched: true,
  profileId: true,
  subjectId: true,
  subjectType: true,
  triggeredById: true,
  updatedAt: true
};
const modelApiIdentifier = "anonymizationEvent";
const pluralModelApiIdentifier = "anonymizationEvents";
;
;
;
;
;
const operations = [
  {
    type: "findOne",
    operationName: modelApiIdentifier,
    modelApiIdentifier,
    findByVariableName: "id",
    defaultSelection: DefaultAnonymizationEventSelection,
    namespace: null
  },
  {
    type: "maybeFindOne",
    operationName: modelApiIdentifier,
    modelApiIdentifier,
    findByVariableName: "id",
    defaultSelection: DefaultAnonymizationEventSelection,
    namespace: null
  },
  {
    type: "findMany",
    operationName: pluralModelApiIdentifier,
    modelApiIdentifier,
    defaultSelection: DefaultAnonymizationEventSelection,
    namespace: null
  },
  {
    type: "findFirst",
    operationName: pluralModelApiIdentifier,
    modelApiIdentifier,
    defaultSelection: DefaultAnonymizationEventSelection,
    namespace: null
  },
  {
    type: "maybeFindFirst",
    operationName: pluralModelApiIdentifier,
    modelApiIdentifier,
    defaultSelection: DefaultAnonymizationEventSelection,
    namespace: null
  },
  {
    type: "findOne",
    operationName: pluralModelApiIdentifier,
    functionName: "findById",
    findByField: "id",
    findByVariableName: "id",
    modelApiIdentifier,
    defaultSelection: DefaultAnonymizationEventSelection,
    namespace: null
  },
  {
    type: "maybeFindOne",
    operationName: pluralModelApiIdentifier,
    functionName: "maybeFindById",
    findByField: "id",
    findByVariableName: "id",
    modelApiIdentifier,
    defaultSelection: DefaultAnonymizationEventSelection,
    namespace: null
  },
  {
    type: "computedView",
    operationName: "view",
    functionName: "view",
    gqlFieldName: "anonymizationEventGellyView",
    namespace: null,
    variables: {
      query: { type: "String", required: true },
      args: { type: "JSONObject" }
    }
  }
];
const AnonymizationEventManager = buildModelManager(
  modelApiIdentifier,
  pluralModelApiIdentifier,
  DefaultAnonymizationEventSelection,
  operations
);
export {
  AnonymizationEventManager,
  DefaultAnonymizationEventSelection
};
//# sourceMappingURL=AnonymizationEvent.js.map
